import { get, post } from '@/services/awsAmplify'

export enum VoteType {
  Upvote = 'UPVOTE',
  Downvote = 'DOWNVOTE',
}

export interface IVoteStatusDTO {
  vote?: {
    voteType: VoteType
    timestamp: string
  }
  voter: {
    id: UUID
    remainVotes: number
    hasVotedOnce: boolean
  }
  contestant: {
    id: UUID
    userId: string
    votes: number
  }
  contest: {
    id: UUID
  }
}

export const getVoteStatus = async (contestantId: UUID) => {
  return get({
    path: `/vote/${contestantId}`,
  }) as Promise<IVoteStatusDTO>
}

export interface IVoteParams {
  contestantId: string
  voteType: VoteType
}

export const vote = async ({ contestantId, voteType }: IVoteParams) => {
  const data: IVoteStatusDTO = (await post({
    path: `/vote`,
    params: {
      contestantId,
      voteType,
    },
  })) as unknown as IVoteStatusDTO

  return data
}
